<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
      <navigator />
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
      <div class="cs-fullHeight cs-contentContainer-right">
        <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
          <el-row class="panel-header">
            <el-col>
              <breadcrumbNavigationBar :data="breadcrumbNavigationBarData"></breadcrumbNavigationBar>
            </el-col>
          </el-row>
          <div>
            <accountProfile :showBack="false" :dataIn="accountProfileDataIn" />
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { ObjectEx } from "vue-objectex";

export default {
  name: "accountDetail",
  components: {
    navigator: () => import("@/components/navigator"),
    breadcrumbNavigationBar: () =>
      import("@/components/common/breadcrumbNavigationBar"),
    accountProfile: () => import("@/components/studyAbroad/accountProfile"),
  },
  data() {
    return {
      routeQuery: {},
      breadcrumbNavigationBarData: new ObjectEx(
        [
          {
            key: "name",
            value: "真留",
          },
          {
            key: "currentName",
            value: "真留账目详情",
          },
          {
            key: "navList",
            value: [],
          },
        ],
        {
          updateNavList(newNavList) {
            this.navList = newNavList;
          },
        }
      ),
      accountProfileDataIn: {
        studentId: 0,
      },
    };
  },
  created() {
    this.routeQuery = this.$route.query;
    this.updateNavListByRoute();
    this.resetAccountProfileDataIn();
  },
  methods: {
    updateNavListByRoute() {
      let navList;
      try {
        navList = this.$cryptoJS.enc.Base64.decode(this.routeQuery.navList);
        navList = JSON.parse(navList);
      } catch (error) {
        return;
      }
      if (Object.typeOf(navList) !== "array") return;

      let bnbNavList = [];
      navList.forEach((navPath) => {
        let name;
        switch (navPath) {
          case "/studyAbroad/salesQuery":
            name = "真留实时数据搜索";
            break;
          case "/studyAbroad/runningAccount":
            name = "真留账目流水";
            break;
        }

        if (!!name) {
          if (bnbNavList.length === 0) this.$route.meta.menuActive = navPath;
          bnbNavList.push({
            basePath: navPath,
            link: navPath,
            name,
          });
        }
      });
      this.breadcrumbNavigationBarData.updateNavList(bnbNavList);
    },

    // accountProfile相关方法
    resetAccountProfileDataIn() {
      this.accountProfileDataIn = {
        workflowId: this.routeQuery.workflowId,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-contentContainer-right-content {
  padding: 0 !important;

  .panel-header {
    padding: 20px 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/studyAbroad/accountDetail.vue